
import {
    closestCenter,
    DndContext,
    KeyboardSensor,
    MouseSensor,
    PointerSensor,
    useSensor,
    useSensors
} from '@dnd-kit/core';
import {
    restrictToHorizontalAxis,
    restrictToVerticalAxis
} from '@dnd-kit/modifiers';
import { useEffect, useState } from 'react';
type Props = {

    onDragEnd: (event: any) => void;
    children: React.ReactNode;
    orientation: string;

}
function ContextDnD({ onDragEnd, children, orientation }: Props) {
    const activationConstraint = orientation === 'horizontal' ? restrictToHorizontalAxis : restrictToVerticalAxis
    const [isDragging, setIsDragging] = useState(false);
    useScrollLock(isDragging, orientation);
  
    const mouseSensor = useSensor(MouseSensor, {
        activationConstraint,
    } as any);

    const sensors = useSensors(
        mouseSensor,
        useSensor(PointerSensor),
        useSensor(KeyboardSensor)
    );

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            // onDragEnd={onDragEnd}
            onDragStart={() => setIsDragging(true)}
            onDragEnd={(event: any) => {
                onDragEnd(event)
                setIsDragging(false)
            }}
            onDragCancel={() => setIsDragging(false)}
            modifiers={[activationConstraint]}
        >

            {children}
        </DndContext>
    )
}
function useScrollLock(isDragging: boolean, orientation: string) {
    useEffect(() => {
      const container = document.getElementById("swimlane_Container");
      if (!container) return;

      const lastScrollLeft = container.scrollLeft;
      const lastScrollTop = container.scrollTop;

      const lockScroll = (event: Event) => {
        if (orientation === "horizontal") {
          container.scrollTop = lastScrollTop; // Prevent vertical scrolling
        } else {
          container.scrollLeft = lastScrollLeft; // Prevent horizontal scrolling
        }
        event.preventDefault();
      };

      if (isDragging) {
        if (orientation === "horizontal") {
          container.style.overflowY = "hidden"; // Disable vertical scrolling
        } else {
          container.style.overflowX = "hidden"; // Disable horizontal scrolling
        }
        
        container.addEventListener("wheel", lockScroll, { passive: false });
        container.addEventListener("touchmove", lockScroll, { passive: false });
      }

      return () => {
        if (container) {
          container.style.overflowY = "";
          container.style.overflowX = "";
          container.removeEventListener("wheel", lockScroll);
          container.removeEventListener("touchmove", lockScroll);
        }
      };
    }, [isDragging, orientation]);
  }
export default ContextDnD;